module.exports = __webpack_public_path__ + "img/img-4.b80ea7e0.png";